import useResources from "./use-resources";
import type { DocumentFile } from "../models/document";

export default function useSignatureAnnexes(fileId?: number) {
  const {
    resources: annexes,
    error,
    isLoading,
  } = useResources<DocumentFile>(
    fileId ? `oodrive/sign/${fileId}/annexes` : null,
  );

  return { annexes, error, isLoading };
}
